import classNames from 'classnames'
import dayjs from 'dayjs'
import { orderBy } from 'lodash'
import Card from 'react-bootstrap/esm/Card'
import CardBody from 'react-bootstrap/esm/CardBody'
import { Proposta } from '../../types'
import { CardTable } from '../../components/StickyTable'

interface PropostaStoricoInterface {
  logs: Proposta['logs']
}

type CardStoricoProps = {
  proposta: PropostaStoricoInterface | undefined
}

export function CardStorico({ proposta }: CardStoricoProps) {
  return (
    <Card className="mt-3 mb-5">
      <CardBody>
        <div className="py-1 border-bottom">
          <div className="d-flex justify-content-between">
            <h4 className="heading-h4 d-flex align-items-center">
              <span className="material-icons text-secondary me-2">history</span>
              Storico
            </h4>
          </div>
        </div>
        <div className="mt-3">
          <CardTable className="w-100">
            <thead>
              <tr>
                <th>Data</th>
                <th>Utente</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              {orderBy(proposta?.logs, ['data_ora'], ['desc'])?.map((storia) => (
                <tr key={storia.id}>
                  <td className="border-bottom py-2">{dayjs(storia.data_ora).format('DD.MM.YYYY - HH:mm')}</td>
                  <td className="border-bottom py-2">
                    <span className="p-md me-1 text-black">
                      {storia.user_fullname}
                      {!storia.user_fullname && storia.stato === 'accettata' && <i>Cliente</i>}
                    </span>
                  </td>
                  <td className="border-bottom py-2">
                    <span className={classNames('badge badge-state-all text-capitalize ')}>{storia.stato}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </CardTable>
        </div>
      </CardBody>
    </Card>
  )
}
